
































































































import { Component, Prop, Watch,Vue } from 'vue-property-decorator'
import {swiper, swiperSlide} from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
@Component({
    components: {
        swiper,
        swiperSlide
    }
})
export default class DivSwiper extends Vue {
    @Prop({
        default: '',
    })
    public description: string;
    @Prop()
    public imgList:any
    @Prop()
    public indexs:any
    @Prop()
    public cnt:any
    public swiperOption0:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt0',
          prevEl: '.swiper-button-ppp0'
        },
    }
     public swiperOption1:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt1',
          prevEl: '.swiper-button-ppp1'
        },
    }
    public swiperOption2:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt2',
          prevEl: '.swiper-button-ppp2'
        },
    }
    public swiperOption3:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt3',
          prevEl: '.swiper-button-ppp3'
        },
    }
    public swiperOption4:any = {
        observeParents: true,
        observer: true,
        freeMode: true,
        slidesPerView: 'auto',
        centeredSlides:false,
        spaceBetween: 10,
        loop:false,
        navigation: {
          nextEl: '.swiper-button-ntt4',
          prevEl: '.swiper-button-ppp4'
        },
    }
    getStrWithSimonFromNum(num){
        let numstr = num.toString();
        let arr = numstr.split('.');
        if(arr.length>1){
            return  arr[0].toString().includes('-')?'-'+arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('')+'.'+arr[1]:arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('')+'.'+arr[1];
        }else{
            return  arr[0].toString().includes('-')?'-'+arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join(''):arr[0].toString().split('').reverse().join('').match(/\d{1,3}/g).join(',').split('').reverse().join('');
        }
    }
    public mounted(){
        console.log('this.imgList', this.imgList)
    //     this.swiperOption = {
    //     observeParents: true,
    //     observer: true,
    //     freeMode: true,
    //     slidesPerView: 'auto',
    //     centeredSlides:false,
    //     spaceBetween: 10,
    //     loop:false,
    //     navigation: {
    //       nextEl: '.swiper-button-ntt1',
    //       prevEl: '.swiper-button-ppp1'
    //     },
    //     pagination:this.indexs
    //   }
    }
    // get swiperIndex(){
    //     let swiper:any = (this.$refs.sinoSwiper as any).swiper;
    //     console.log('swiper-->',swiper);
    //     return ''
    // }
}
